import React from "react";

const MainSection = ({ children }) => {
  return (
    <div className="p-4 sm:p-6 pt-24 sm:pt-28 sm:ml-64 min-h-screen bg-gray-50/50 w-auto min-w-0 max-w-full overflow-x-hidden">
      <div className="w-full max-w-full">{children}</div>
    </div>
  );
};

export default MainSection;
